import baseUrlPath from "./baseUrlPath";
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const UserApi = createApi({
    reducerPath: "userApi",
    baseQuery:fetchBaseQuery({
        baseUrl:baseUrlPath.test
    }),
    tagTypes:["users"],
    endpoints:(builder) => ({
        loginUser:builder.mutation({
            query:(userCredentials) =>({
                url:"user/loginuser",
                method:"POST",
                headers:{
                    "content-type":"application/json",
                },
                body:userCredentials,
            }),
            invalidatesTags:["users"]
        }),
         createUser:builder.mutation({
            query:(userCredentials) =>({
                url:"user/create",
                method:"POST",
                headers:{
                    "content-type":"application/json",
                },
                body:userCredentials,
                 credentials: "include",
            }),
            invalidatesTags:["users"]
        }),


    }),
});

export const {
useLoginUserMutation,
useCreateUserMutation
} = UserApi;